export const siteName = "911吃瓜网";

export const features = [
  {
    icon: "ri-flashlight-line",
    title: "实时追踪",
    desc: "24小时不间断监控全网爆料动态，第一时间推送最新吃瓜内容，让你永远站在吃瓜最前线。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多方核实",
    desc: "每条爆料均经过多渠道交叉验证，标注信息来源与可信度评级，拒绝虚假谣言，做最靠谱的吃瓜平台。",
  },
  {
    icon: "ri-group-line",
    title: "瓜友社区",
    desc: "百万瓜友在线互动讨论，热门话题实时热议，你的每一个观点都能引发全网共鸣与深度探讨。",
  },
  {
    icon: "ri-smartphone-line",
    title: "随时随地",
    desc: "适配手机、平板、电脑全终端浏览体验，通勤路上、午休间隙、睡前时光，吃瓜随时随地不设限。",
  },
];

export const indexTopics = [
  {
    title: "明星恋情",
    count: 1286,
    image: "https://readdy.ai/api/search-image?query=Romantic%20celebrity%20couple%20walking%20together%20on%20a%20city%20street%20at%20dusk%20with%20paparazzi%20style%20candid%20photography%2C%20warm%20golden%20hour%20lighting%2C%20blurred%20urban%20background%2C%20soft%20bokeh%20effect%2C%20editorial%20entertainment%20magazine%20aesthetic%2C%20subtle%20motion%20blur%2C%20intimate%20yet%20public%20atmosphere&width=400&height=280&seq=index-topic-01&orientation=landscape",
    tag: "热",
  },
  {
    title: "综艺翻车",
    count: 953,
    image: "https://readdy.ai/api/search-image?query=Dramatic%20television%20variety%20show%20stage%20with%20colorful%20lights%20and%20surprised%20expressions%2C%20comedy%20moment%20captured%20on%20set%2C%20bright%20studio%20lighting%2C%20entertainment%20production%20atmosphere%2C%20vibrant%20warm%20colors%2C%20dynamic%20composition%2C%20professional%20broadcast%20equipment%20in%20background&width=400&height=280&seq=index-topic-02&orientation=landscape",
    tag: "爆",
  },
  {
    title: "剧组路透",
    count: 847,
    image: "https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20crew%20members%20and%20cameras%2C%20candid%20moments%20during%20shooting%2C%20warm%20cinematic%20lighting%2C%20professional%20movie%20production%20equipment%2C%20outdoor%20location%20set%2C%20natural%20sunlight%20filtering%20through%20trees%2C%20documentary%20photography%20style&width=400&height=280&seq=index-topic-03&orientation=landscape",
    tag: "新",
  },
  {
    title: "网红翻车",
    count: 1124,
    image: "https://readdy.ai/api/search-image?query=Modern%20social%20media%20influencer%20studio%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%2C%20contemporary%20digital%20content%20creation%20workspace%2C%20clean%20bright%20aesthetic%2C%20warm%20neutral%20tones%2C%20lifestyle%20photography%20with%20soft%20natural%20window%20light%2C%20minimalist%20background%20with%20subtle%20texture&width=400&height=280&seq=index-topic-04&orientation=landscape",
  },
  {
    title: "选秀黑幕",
    count: 762,
    image: "https://readdy.ai/api/search-image?query=Talent%20competition%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20judges%20panel%2C%20theatrical%20stage%20design%20with%20red%20and%20gold%20elements%2C%20dramatic%20lighting%20creating%20tension%20atmosphere%2C%20professional%20theater%20photography%2C%20intense%20mood%20with%20contrasting%20shadows%2C%20performance%20venue%20setting&width=400&height=280&seq=index-topic-05&orientation=landscape",
    tag: "热",
  },
  {
    title: "直播带货",
    count: 689,
    image: "https://readdy.ai/api/search-image?query=Livestream%20shopping%20studio%20setup%20with%20multiple%20product%20displays%20on%20desk%2C%20modern%20e-commerce%20broadcast%20room%2C%20warm%20ring%20lighting%2C%20professional%20streaming%20equipment%2C%20organized%20product%20arrangement%2C%20contemporary%20Chinese%20digital%20commerce%20aesthetic%2C%20bright%20inviting%20atmosphere&width=400&height=280&seq=index-topic-06&orientation=landscape",
  },
  {
    title: "婚变八卦",
    count: 1058,
    image: "https://readdy.ai/api/search-image?query=Emotional%20dramatic%20scene%20with%20soft%20melancholic%20lighting%2C%20two%20people%20walking%20away%20from%20each%20other%20on%20an%20urban%20street%20at%20dusk%2C%20cinematic%20storytelling%20composition%2C%20moody%20atmosphere%20with%20warm%20and%20cool%20color%20contrast%2C%20film%20photography%20aesthetic%20with%20grain%20texture%2C%20nostalgic%20and%20contemplative%20mood&width=400&height=280&seq=index-topic-07&orientation=landscape",
  },
  {
    title: "官司纠纷",
    count: 534,
    image: "https://readdy.ai/api/search-image?query=Modern%20courthouse%20exterior%20with%20dramatic%20cloudy%20sky%2C%20legal%20document%20and%20gavel%20concept%20photography%2C%20formal%20and%20serious%20atmosphere%2C%20clean%20architectural%20lines%2C%20professional%20journalism%20photography%20style%2C%20warm%20natural%20lighting%20creating%20depth%20and%20dimension%2C%20symbolic%20composition&width=400&height=280&seq=index-topic-08&orientation=landscape",
  },
  {
    title: "整容风波",
    count: 891,
    image: "https://readdy.ai/api/search-image?query=Modern%20luxury%20beauty%20clinic%20interior%20with%20soft%20ambient%20lighting%2C%20elegant%20minimalist%20aesthetic%2C%20warm%20neutral%20color%20palette%2C%20professional%20medical%20beauty%20equipment%20in%20background%2C%20sophisticated%20atmosphere%2C%20lifestyle%20photography%20with%20depth%20of%20field%2C%20clean%20and%20refined%20visual%20style&width=400&height=280&seq=index-topic-09&orientation=landscape",
  },
];

export const mediaItems = [
  {
    title: "独家实拍：某顶流深夜密会神秘女子，全程高清画面",
    views: "328万",
    duration: "05:42",
    image: "https://readdy.ai/api/search-image?query=Nighttime%20urban%20street%20scene%20with%20dramatic%20street%20lighting%2C%20mysterious%20atmosphere%2C%20city%20nightlife%20photography%2C%20warm%20amber%20street%20lights%20creating%20cinema%20noir%20aesthetic%2C%20blurred%20figures%20in%20background%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20selective%20focus%2C%20film%20grain%20texture&width=640&height=400&seq=media-01&orientation=landscape",
  },
  {
    title: "录音曝光：某综艺导师私下吐槽学员，句句扎心",
    views: "256万",
    duration: "03:18",
    image: "https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20interior%20with%20warm%20ambient%20lighting%2C%20vintage%20microphone%20on%20stand%2C%20sound%20mixing%20console%20in%20background%2C%20atmospheric%20creative%20workspace%2C%20warm%20color%20palette%20with%20subtle%20glow%2C%20editorial%20photography%20style%2C%20artistic%20depth%20of%20field&width=640&height=400&seq=media-02&orientation=landscape",
  },
  {
    title: "现场直击：品牌活动后台混乱场面，工作人员崩溃",
    views: "198万",
    duration: "08:55",
    image: "https://readdy.ai/api/search-image?query=Backstage%20chaos%20at%20fashion%20event%20with%20scattered%20clothing%20racks%20and%20hurried%20crew%20members%2C%20dramatic%20backstage%20lighting%2C%20candid%20documentary%20photography%20style%2C%20warm%20intense%20atmosphere%2C%20behind%20the%20scenes%20energy%2C%20editorial%20fashion%20week%20aesthetic%2C%20dynamic%20motion%20blur&width=640&height=400&seq=media-03&orientation=landscape",
  },
  {
    title: "重磅实测：某大牌代言人翻车全过程，品牌连夜解约",
    views: "442万",
    duration: "11:20",
    image: "https://readdy.ai/api/search-image?query=Corporate%20press%20conference%20room%20with%20empty%20podium%20and%20scattered%20papers%2C%20dramatic%20tension%20atmosphere%2C%20professional%20lighting%2C%20abandoned%20press%20event%20setting%2C%20cinematic%20documentary%20style%2C%20warm%20yet%20somber%20color%20grading%2C%20journalistic%20photography%20composition%20with%20strong%20narrative%20mood&width=640&height=400&seq=media-04&orientation=landscape",
  },
];

export const cards = [
  {
    title: "某女星被曝与导演深夜对剧本，助理全程守门引热议",
    category: "明星恋情",
    time: "2小时前",
    hot: "9.8万",
    image: "https://readdy.ai/api/search-image?query=Two%20people%20in%20discussion%20at%20nighttime%20outdoor%20cafe%20with%20warm%20ambient%20lighting%2C%20candid%20paparazzi%20style%20photography%2C%20mysterious%20romantic%20atmosphere%2C%20urban%20night%20scene%20with%20soft%20bokeh%20city%20lights%20background%2C%20cinematic%20composition%20with%20intimate%20framing%2C%20editorial%20entertainment%20magazine%20aesthetic&width=640&height=420&seq=card-01&orientation=landscape",
  },
  {
    title: "综艺录制现场突发意外，某流量小生当场发飙罢录",
    category: "综艺翻车",
    time: "5小时前",
    hot: "7.2万",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20television%20studio%20moment%20with%20intense%20confrontation%20atmosphere%2C%20bright%20stage%20lights%20creating%20harsh%20shadows%2C%20professional%20TV%20production%20set%2C%20entertainment%20industry%20tension%20captured%20in%20editorial%20photography%20style%2C%20warm%20dramatic%20lighting%2C%20documentary%20realism%20with%20cinematic%20composition&width=640&height=420&seq=card-02&orientation=landscape",
  },
  {
    title: "某品牌直播销售额造假被实锤，数据前后矛盾离谱",
    category: "直播带货",
    time: "8小时前",
    hot: "6.5万",
    image: "https://readdy.ai/api/search-image?query=Modern%20e-commerce%20livestream%20control%20room%20with%20multiple%20data%20screens%20displaying%20graphs%20and%20numbers%2C%20tension%20and%20pressure%20atmosphere%2C%20professional%20streaming%20setup%2C%20warm%20monitor%20glow%20lighting%2C%20documentary%20photography%20style%2C%20contemporary%20Chinese%20digital%20commerce%20workspace%2C%20high-tech%20yet%20dramatic%20mood&width=640&height=420&seq=card-03&orientation=landscape",
  },
  {
    title: "知情人士爆料：某知名夫妻档已分居半年，细节令人唏嘘",
    category: "婚变八卦",
    time: "12小时前",
    hot: "5.8万",
    image: "https://readdy.ai/api/search-image?query=Empty%20luxury%20apartment%20with%20personal%20items%20half%20packed%20in%20boxes%2C%20melancholic%20atmosphere%20with%20soft%20natural%20window%20light%20creating%20shadows%2C%20storytelling%20interior%20photography%2C%20warm%20yet%20somber%20color%20palette%2C%20emotional%20narrative%20through%20objects%20and%20space%2C%20residential%20setting%20with%20elegant%20furniture&width=640&height=420&seq=card-04&orientation=landscape",
  },
  {
    title: "选秀节目内定名单流出，多位选手排名与现场表现不符",
    category: "选秀黑幕",
    time: "16小时前",
    hot: "4.3万",
    image: "https://readdy.ai/api/search-image?query=Confidential%20document%20on%20desk%20with%20dramatic%20shadow%20from%20window%20blinds%2C%20corporate%20mystery%20atmosphere%2C%20warm%20office%20lighting%20creating%20noir%20aesthetic%2C%20professional%20investigative%20journalism%20photography%2C%20tension%20and%20secrecy%20mood%2C%20cinematic%20composition%20with%20selective%20focus%20on%20paper%20details&width=640&height=420&seq=card-05&orientation=landscape",
  },
  {
    title: "某网红被扒学历造假，相关证书经查实为伪造文件",
    category: "网红翻车",
    time: "20小时前",
    hot: "3.9万",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20desk%20with%20scattered%20documents%20under%20warm%20desk%20lamp%20lighting%2C%20investigative%20atmosphere%2C%20late%20night%20research%20scene%2C%20warm%20amber%20light%20creating%20dramatic%20shadows%2C%20editorial%20photography%20style%2C%20intellectual%20mystery%20mood%2C%20clean%20composition%20with%20depth%20and%20texture&width=640&height=420&seq=card-06&orientation=landscape",
  },
];

export const faqItems = [
  {
    q: "911吃瓜网的爆料内容靠谱吗？",
    a: "我们的爆料内容均来自多渠道交叉验证，每条信息都会标注来源和可信度评级。同时我们会持续跟进事件进展，及时更新最新动态，确保内容真实可靠。",
  },
  {
    q: "如何第一时间获取最新吃瓜爆料？",
    a: "建议将本站添加到浏览器收藏夹，或关注我们的社交媒体账号。我们全天候实时更新，重大爆料会在首页置顶展示，确保你不会错过任何热门话题。",
  },
  {
    q: "可以在平台上投稿爆料吗？",
    a: "当然可以！我们非常欢迎知情人士提供真实有效的爆料线索。请通过页面底部的联系方式或投稿入口提交，我们会严格保护爆料人隐私信息。",
  },
  {
    q: "平台上的内容是否会侵犯隐私？",
    a: "911吃瓜网严格遵守法律法规，所有内容均在合法合规范围内进行报道。我们会对涉及个人隐私的敏感信息进行脱敏处理，维护健康的网络传播环境。",
  },
  {
    q: "为什么叫911吃瓜网？",
    a: "911代表着紧急和第一时间的含义，寓意我们像紧急热线一样，以最快速度传递最新鲜的吃瓜资讯。做一个靠谱又高效的吃瓜第一站！",
  },
  {
    q: "平台内容多久更新一次？",
    a: "我们保持全天候不间断更新，热点事件发生后15分钟内即可看到相关爆料。每天至少推送50条以上新鲜内容，重大事件实时滚动追踪报道。",
  },
];

export const comments = [
  {
    name: "吃瓜不嫌事大",
    time: "3小时前",
    content: "这个料太猛了！我蹲了一整天终于等到实锤，911吃瓜网果然从不让人失望，比隔壁快太多了！",
    likes: 2836,
  },
  {
    name: "理性吃瓜群众",
    time: "5小时前",
    content: "希望能多一些证据确凿的爆料，少一些捕风捉影。不过总体来说这个平台的信息质量还是比别家好。",
    likes: 1521,
  },
  {
    name: "娱乐圈观察者",
    time: "7小时前",
    content: "作为圈内人，我只能说这里爆出来的大部分内容都八九不离十。有些细节虽然夸张了，但大方向没错。",
    likes: 3408,
  },
  {
    name: "每日一瓜",
    time: "9小时前",
    content: "自从关注了这个站，我每天上班第一件事就是刷一遍。同事都说我是办公室的人形八卦播报机哈哈哈！",
    likes: 1956,
  },
];

export const aboutContent = {
  title: "关于911吃瓜网",
  desc: "911吃瓜网是国内领先的娱乐八卦资讯聚合平台，致力于为全网吃瓜爱好者提供最快、最全、最靠谱的爆料内容。平台由资深娱乐媒体人创立，拥有一支专业的编辑团队和遍布全国的信息采集网络，覆盖明星恋情、综艺翻车、剧组路透、网红事件、选秀黑幕、直播带货、婚变八卦等多个热门领域。",
  stats: [
    { label: "日均更新", value: "200+" },
    { label: "瓜友用户", value: "500万+" },
    { label: "累计爆料", value: "10万+" },
    { label: "覆盖话题", value: "30+" },
  ],
};

export const updates = [
  {
    time: "2026-07-30 14:25",
    content: "【最新】某头部综艺节目录制现场发生冲突，制片人与嘉宾激烈争执，录制被迫中断30分钟。",
    tag: "热",
  },
  {
    time: "2026-07-30 12:10",
    content: "【独家】知名导演被拍到与神秘女子同游三亚，举止亲密疑似新恋情曝光，经纪人暂未回应。",
    tag: "新",
  },
  {
    time: "2026-07-30 09:45",
    content: "【追踪】某品牌解约风波持续发酵，律师函已发出，品牌方要求赔偿违约金约2000万元。",
    tag: "爆",
  },
  {
    time: "2026-07-30 07:30",
    content: "【辟谣】昨日网传某顶流被捕消息不实，工作室已发声明否认，并称将通过法律途径维权。",
  },
  {
    time: "2026-07-29 22:15",
    content: "【热议】某选秀节目总决赛评分被质疑，现场观众晒出投票截图，与官方公布数据相差悬殊。",
    tag: "热",
  },
  {
    time: "2026-07-29 18:50",
    content: "【快讯】知名网红直播间突然被封，据称因涉及违规宣传，平台已启动调查程序。",
  },
  {
    time: "2026-07-29 15:20",
    content: "【爆料】某女星被前助理爆料私下耍大牌，对待工作人员态度恶劣，多位圈内人转发支持。",
    tag: "新",
  },
];

export const topicTags = [
  { name: "顶流恋情", count: "128万" },
  { name: "综艺翻车现场", count: "96万" },
  { name: "直播翻车", count: "85万" },
  { name: "明星解约", count: "73万" },
  { name: "选秀内幕", count: "68万" },
  { name: "网红塌房", count: "62万" },
  { name: "婚变传闻", count: "55万" },
  { name: "代言风波", count: "48万" },
  { name: "剧组纷争", count: "42万" },
  { name: "歌曲抄袭", count: "36万" },
  { name: "综艺矛盾", count: "31万" },
];

export const rankingItems = [
  {
    rank: 1,
    title: "某顶流男星深夜密会神秘女，助理全程放哨引全网争议",
    hot: "128万",
    change: "up",
  },
  {
    rank: 2,
    title: "知名综艺录制现场突发冲突，制片人与导师激烈争吵",
    hot: "96万",
    change: "up",
  },
  {
    rank: 3,
    title: "品牌连夜解约风波：代言人翻车全过程完整时间线曝光",
    hot: "85万",
    change: "new",
  },
  {
    rank: 4,
    title: "某网红直播带货数据造假被实锤，成交额前后相差十倍",
    hot: "73万",
    change: "up",
  },
  {
    rank: 5,
    title: "知情人曝某明星夫妻已分居一年，朋友圈互动为零",
    hot: "62万",
    change: "down",
  },
];

export const contactInfo = {
  title: "联系我们",
  desc: "如有爆料线索、商务合作或侵权投诉，欢迎通过以下方式与我们取得联系。爆料人信息将严格保密。",
  email: "tips@911chigua.com",
  wechat: "911chigua",
};

export const carouselItems = [
  {
    title: "2026娱乐圈上半年十大重磅事件盘点",
    desc: "从顶流塌房到综艺翻车，从明星婚变到品牌解约，我们用一篇长文带你回顾这半年最劲爆的吃瓜现场。每一件都曾炸翻全网热搜。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20concept%20with%20warm%20red%20and%20gold%20abstract%20elements%2C%20cinematic%20spotlight%20beams%20crossing%20dark%20background%2C%20vintage%20newspaper%20texture%20overlay%2C%20mysterious%20and%20glamorous%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20abstract%20representation%20of%20breaking%20celebrity%20news%2C%20rich%20warm%20tones%20with%20deep%20shadows%2C%20artistic%20composition%20with%20layered%20visual%20elements&width=1200&height=560&seq=carousel-01&orientation=landscape",
    tag: "年度盘点",
  },
  {
    title: "深度揭秘：娱乐圈资本博弈背后的势力版图",
    desc: "明星背后的经纪公司、投资人、平台方，一张错综复杂的关系网正在重塑整个娱乐行业。谁是真正的幕后操盘手？",
    image: "https://readdy.ai/api/search-image?query=Abstract%20corporate%20power%20structure%20visualization%20with%20warm%20amber%20tones%2C%20sophisticated%20dark%20boardroom%20aesthetic%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20modern%20business%20intrigue%20atmosphere%2C%20cinematic%20composition%20with%20depth%20and%20mystery%2C%20professional%20photography%20style%2C%20layered%20geometric%20patterns%20suggesting%20network%20connections&width=1200&height=560&seq=carousel-02&orientation=landscape",
    tag: "深度分析",
  },
  {
    title: "从素人到顶流：那些一夜爆红背后的推手故事",
    desc: "流量时代的造星逻辑已经彻底改变。MCN机构、短视频平台、数据公司，一套精密的造星流水线正在批量生产网红明星。",
    image: "https://readdy.ai/api/search-image?query=Modern%20digital%20content%20creation%20studio%20with%20multiple%20screens%20and%20cameras%2C%20warm%20cinematic%20lighting%2C%20behind%20the%20scenes%20of%20internet%20celebrity%20culture%2C%20professional%20streaming%20setup%20with%20artistic%20composition%2C%20dramatic%20atmosphere%20with%20golden%20hour%20glow%2C%20contemporary%20Chinese%20media%20production%20aesthetic%2C%20documentary%20editorial%20photography%20style&width=1200&height=560&seq=carousel-03&orientation=landscape",
    tag: "行业观察",
  },
  {
    title: "吃瓜经济学：一条爆料如何撬动数十亿市场",
    desc: "当娱乐八卦变成注意力经济的硬通货，一条爆料可以引发股价波动、品牌市值蒸发、代言合约解除。吃瓜，早已不只是娱乐。",
    image: "https://readdy.ai/api/search-image?query=Financial%20trading%20floor%20atmosphere%20merged%20with%20entertainment%20industry%20elements%2C%20dramatic%20warm%20golden%20lighting%2C%20abstract%20representation%20of%20media%20market%20impact%2C%20modern%20cinematic%20composition%2C%20sophisticated%20business%20journalism%20aesthetic%2C%20rich%20amber%20and%20deep%20shadow%20contrast%2C%20professional%20documentary%20photography%20with%20artistic%20approach&width=1200&height=560&seq=carousel-04&orientation=landscape",
    tag: "财经视角",
  },
];

export const appInfo = {
  title: "随时随地，吃瓜不停",
  desc: "扫码下载911吃瓜网APP，第一时间接收推送通知，重大爆料不再错过。支持iOS与Android双平台。",
  image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20Chinese%20entertainment%20news%20app%20interface%20with%20warm%20red%20and%20gold%20theme%20color%2C%20elegant%20mobile%20UI%20design%20with%20card%20layout%2C%20dark%20mode%20aesthetic%20with%20rich%20warm%20accents%2C%20floating%20notification%20badges%2C%20contemporary%20app%20design%2C%20clean%20typography%2C%20minimal%20yet%20sophisticated%20visual%20style%2C%20product%20mockup%20photography%20on%20subtle%20gradient%20background&width=400&height=720&seq=app-mockup&orientation=portrait",
};

export const siteSlogan = "吃瓜第一手，爆料天天有";

export const heroStats = [
  { label: "每日更新", value: "200+条" },
  { label: "瓜友聚集", value: "500万+" },
  { label: "全网首发", value: "独家追踪" },
];